import { PayloadAction } from '@reduxjs/toolkit';
import { StreamMessageModel, StreamModel } from '$store/models';
import { CameraTypeEnum } from '$shared/constants';

export enum LiveStatus {
  INIT = 'INIT', // Инициализация, получаем информацию создала модель лайв или нет.
  READY = 'READY',
  CREATING = 'CREATING',
  CONNECTING = 'CONNECTING',
  NO_ACCESS = 'NO_ACCESS',
  ONLINE = 'ONLINE',
  ACCESS_CAM_ERROR = 'ACCESS_CAM_ERROR',
  ACCESS_MIC_ERROR = 'ACCESS_MIC_ERROR',
  ACCESS_CAM_AND_MIC_ERROR = 'ACCESS_CAM_AND_MIC_ERROR',
  DISCONNECTED = 'DISCONNECTED',
  RECONNECTION = 'RECONNECTION',
  FINISHED = 'FINISHED',
  BANNED = 'BANNED',
  FAILED = 'FAILED',
}

export enum LiveType {
  PUBLISHER = 'PUBLISHER',
  VIEWER = 'VIEWER',
}

export enum LivePermissionEnum {
  PUBLIC = 'public',
  EROTIC = 'erotic',
  SPONSOR = 'sponsor',
}

export enum LiveHistoryFilterEnum {
  ALL = 'ALL',
  TIPS = 'TIPS',
  SPONSORS = 'SPONSORS',
}

export interface LiveTip {
  eur: number;
  ton: number;
  userId: number;
}

type ModelLiveEndStatistics = {
  audience: string;
  donated: number;
  duration: number;
  streamId: number;
  watched: number;
};

export interface LiveState {
  historyFilter: LiveHistoryFilterEnum;
  streams: StreamModel[];
  type: LiveType;
  tipsTotal: number;
  permission: LivePermissionEnum;
  confirmStop: boolean;
  stream: StreamModel | null;
  mediaStream: MediaStream | null;
  cameras: MediaDeviceInfo[];
  currentCameraId: string | null;
  liveStatus: LiveStatus;
  messages: StreamMessageModel[];
  tipsMessagesCount: number;
  allMessagesLoaded: boolean;
  nextFrom: number;
  online: number;
  micEnabled: boolean;
  cameraName: string;
  reconnecting: boolean;
  togglingCamera: boolean;
  cameraType: CameraTypeEnum;
  sponsors: { [key: number]: boolean };
  message: string;
  focus: boolean;
  showUsersSheet: boolean;
  showTotalTipsSheet: boolean;
  actionsSheetUserId: number | null;
  tips: LiveTip[];
  onlineUsers: number[];
  totalTipsLoadingStatus: 'loading' | 'loaded' | 'failed';
  onlineUsersLoadingStatus: 'loading' | 'loaded' | 'failed';
  endStatistics?: ModelLiveEndStatistics;
}

export type SetLiveStatusAction = PayloadAction<LiveStatus>;
export type SetOnlineUsersAction = PayloadAction<number[]>;
export type GetOnlineUsersAction = PayloadAction<{ skipLoading?: boolean }>;
export type GetTotalTipsAction = PayloadAction<{ skipLoading?: boolean }>;
export type SetTipsUsersAction = PayloadAction<number[]>;
export type SetTotalTipsLoadingStatusAction = PayloadAction<
  LiveState['totalTipsLoadingStatus']
>;
export type SetOnlineUsersLoadingStatusAction = PayloadAction<
  LiveState['onlineUsersLoadingStatus']
>;
export type SetTypeAction = PayloadAction<LiveType>;
export type SetTipsTotalActions = PayloadAction<number>;
export type SetTipsTotalSheetActions = PayloadAction<boolean>;
export type SetOnlineUsersSheetActions = PayloadAction<boolean>;
export type SetConfirmStopAction = PayloadAction<boolean>;
export type SetPermissionAction = PayloadAction<LivePermissionEnum>;
export type SetMessageAction = PayloadAction<string>;
export type SetFocusAction = PayloadAction<boolean>;
export type SetStreamsAction = PayloadAction<StreamModel[]>;
export type SetMicEnabledAction = PayloadAction<boolean>;
export type SetReconnectingAction = PayloadAction<boolean>;
export type ShowActionsSheetAction = PayloadAction<number>;
export type SetTipsAction = PayloadAction<LiveTip[]>;
export type SetHistoryFilterAction = PayloadAction<LiveHistoryFilterEnum>;
export type SetTogglingCameraAction = PayloadAction<boolean>;
export type DeleteMessageAction = PayloadAction<number>;
export type AddMessagesAction = PayloadAction<StreamMessageModel[]>;
export type AddMessageAction = PayloadAction<StreamMessageModel>;
export type UpdateMessageAction = PayloadAction<{
  id: number;
  message: StreamMessageModel;
}>;
export type SetHistoryAction = PayloadAction<{
  sponsors: LiveState['sponsors'];
  online: LiveState['online'];
  nextFrom: LiveState['nextFrom'];
  tipsTotal: LiveState['tipsTotal'];
  messages: LiveState['messages'];
}>;
export type SetMediaStreamAction = PayloadAction<MediaStream | null>;
export type RemoveStreamAction = PayloadAction<number>;
export type SetStreamAction = PayloadAction<StreamModel | null>;
export type SetCamerasAction = PayloadAction<MediaDeviceInfo[]>;
export type SetCameraIdAction = PayloadAction<LiveState['currentCameraId']>;
export type startWatchLiveAction = PayloadAction<number>;
export type SetEndStatisticsActionPayload = PayloadAction<
  ModelLiveEndStatistics | undefined
>;
